import type { ProductGroupPresentationResult } from '@orus.eu/backend'
import { isKnownProduct } from '@orus.eu/product'

export function findDisplayableProductGroup(
  productGroups: readonly ProductGroupPresentationResult[],
  slug: string,
): ProductGroupPresentationResult | undefined {
  const productGroup = productGroups.find((group) => group.slug === slug)
  if (!productGroup) return undefined

  // The page reads per-product tables, which have no entry for a product launched after this bundle was built
  const contents = productGroup.contents.filter((content) => isKnownProduct(content.product))
  return contents.length > 0 ? { ...productGroup, contents } : undefined
}
